<template>
  <v-form ref="categoryForm">
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12>
          <v-text-field
            label="Name"
            outline
            tabindex="1"
            v-model="form.name"
            name="name"
            :hide-details="!errors.has('name')"
            :error="errors.has('name')"
            :error-count="errors.count('name')"
            :error-messages="errors.get('name')"
          ></v-text-field>
        </v-flex>

        <v-flex xs12>
          <v-autocomplete
            v-model="form.permission_groups"
            item-text="name"
            item-value="id"
            :items="permissionGroups"
            label="Permission Groups"
            placeholder="Select Permission Groups"
            height="35"
            multiple
            hide-details
            :small-chips="$vuetify.breakpoint.smAndUp"
            dense
            flat
            outlined
            clearable
          ></v-autocomplete>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn @click="secondaryAction">{{ secondaryActionText }}</v-btn>
      <v-btn color="primary" @click="submit">{{ submitText }}</v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Errors from "@root/helpers/Errors";

export default {
  data() {
    return {
      form: {
        name: "",
        permission_groups: []
      },
      errors: new Errors()
    };
  },

  computed: {
    ...mapGetters("document_center", ["selectedCategory", "permissionGroups"]),

    category() {
      return this.selectedCategory || {};
    },

    secondaryActionText() {
      return this.category ? "Cancel" : "Reset";
    },

    submitText() {
      return this.category ? "Save Changes" : "Create Category";
    }
  },

  methods: {
    ...mapMutations("document_center", ["setCategories"]),

    ...mapActions("document_center", {
      UPDATE_CATEGORY: "updateCategory",
      DELETE_CATEGORY: "deleteCategory"
    }),

    secondaryAction(urlSlug) {
      if (this.category && !_.isString(urlSlug)) {
        urlSlug = this.category.url_slug;
      }

      if (!this.category) {
        this.$refs.categoryForm.reset();
        this.errors.clear();
      }

      if (_.isString(urlSlug)) {
        this.$router.push(`/admin/categories/${urlSlug}`);
      } else {
        this.$router.back();
      }
    },

    submit() {
      this.UPDATE_CATEGORY({
        form: this.form,
        slug: this.category.slug
      })
        .then(category => {
          this.secondaryAction(category.url_slug);
        })
        .catch(error => {
          error = Object.assign({}, error);
          this.errors.record(error.response.data.errors);
        });
    },

    deleteCategory() {
      // this.$swal({
      //   title: "Are you sure?",
      //   text: "This will delete the file associated with other categories!",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonText: "Yes, delete it!"
      // }).then(result => {
      //   if (result.value) {
      //     const payload = {
      //       document_id: this.document.id
      //     };
      //     this.DELETE_DOCUMENT(payload).then(data => {
      //       if (data.success) {
      //         this.$router.replace("/admin/documents/");
      //       }
      //     });
      //   }
      // });
    }
  },

  created() {
    if (this.category) {
      _.forIn(this.form, (value, key) => {
        value = this.category[key];

        if (key === "permission_groups") {
          value = _.map(value, "id");
        }

        if (value) {
          this.$set(this.form, key, value);
        }
      });
    }
  }
};
</script>
